export default {
  path: "/main/story/chat",
  name: "Chat",
  component: () => import("@/views/main/Story/chat.vue"),
  children: []
};
